// removed by extract-text-webpack-plugin
module.exports = {"collapseIcon":"side-nav__collapseIcon____tVuft"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/components/sidebar/side-nav.css
// module id = 721
// module chunks = 0